import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import TabReducer from '../common/tab/tabReducer';
import LancamentoViagemReducer from '../lancamentoViagem/lancamentoViagemReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	lancamentoViagem: LancamentoViagemReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

